import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concat, of } from 'rxjs';
import { concatMap, flatMap, catchError, mergeMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import { NetworkCallService } from '../../../../../src/app/core/services/network-call.service';
import * as newUserPasscode from '../actions/new-user-passcode.actions';
import { INewUserPasscodeRequest, INewUserPasscodeSuccess } from '../models/new-user-passcode.model';
import notify from 'devextreme/ui/notify';
import { SessionStorageIds } from '../../../shared/enums';

@Injectable()
export class NewUserPasscodeEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helpers: HelpersService
  ) {}

  newUserPasscode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(newUserPasscode.loadNewUserPasscodes),
      concatMap(action =>
        this.networkCallService
          .put<INewUserPasscodeRequest, INewUserPasscodeSuccess>('/Authentication/newUserPasscode', action.request)
          .pipe(
            mergeMap((response: INewUserPasscodeSuccess) => {
              if (response.success && !response.passcodeToWeak) {
                // Forgot passcode flow: do not log in; show success and redirect to sign-in
                sessionStorage.removeItem('temp_' + SessionStorageIds.USER_MOBILE);
                sessionStorage.removeItem('temp_' + SessionStorageIds.TOKEN);
                sessionStorage.removeItem('temp_' + SessionStorageIds.REFRESH_TOKEN);
                sessionStorage.removeItem(SessionStorageIds.USER_MOBILE);
                sessionStorage.removeItem(SessionStorageIds.TOKEN);
                sessionStorage.removeItem(SessionStorageIds.REFRESH_TOKEN);

                notify(
                  { message: 'Password changed successfully. You can now use your new passcode to login to portal.', width: 300, shading: true },
                  'success',
                  3000
                );
                this.router.navigateByUrl('auth/sign-up');
              } else if (!response.success && response.passcodeToWeak) {
                notify(
                  {
                      message: `Error! Your passcode is too weak.`,
                      width: 250,
                      shading: true
                  },
                  'error',
                  2000
                );
              }else{
                this.helpers.notifyError('Confirm passcode failed, please try after sometime or contact admin.', 300, 2000);

                // clear temporary session storage
                sessionStorage.removeItem('temp_' + SessionStorageIds.USER_MOBILE);
                sessionStorage.removeItem('temp_' + SessionStorageIds.TOKEN);
                sessionStorage.removeItem('temp_' + SessionStorageIds.REFRESH_TOKEN);
              }
              return concat(of(newUserPasscode.loadNewUserPasscodesSuccess({ response })));
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(newUserPasscode.loadNewUserPasscodesFailure(error));
            })
          )
      )
    )
  );
}
